module.exports = __webpack_public_path__ + "static/GrayGminaKosakowo-a4b5da9a14194c306ece36758456d242.svg";